import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Chip, Typography } from '@mui/material';
import CustomChartWidget, { DashboardWidgetData } from '../../Dashboard/components/CustomChartWidget';
import { FieldDefinition } from '../../Dashboard/utils/widgetSeries';

interface WidgetPreviewDialogProps {
  open: boolean;
  widget: DashboardWidgetData | null;
  previewField?: FieldDefinition;
  onClose: () => void;
}

const WidgetPreviewDialog: React.FC<WidgetPreviewDialogProps> = ({
  open,
  widget,
  previewField,
  onClose,
}) => {
  return (
    <Dialog open={open && !!widget} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
        {widget?.title}
        <Chip label="Preview" size="small" color="info" />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Sample data shown. Real values appear on the dashboard.
        </Typography>
        <Box sx={{ height: 400 }}>
          {widget && !widget.isSystem && (
            <CustomChartWidget
              widget={widget}
              daysCount={14}
              preview
              previewField={previewField}
            />
          )}
          {widget && widget.isSystem && (
            <Typography color="text.secondary" sx={{ mt: 2 }}>
              System widgets render live data on the dashboard.
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WidgetPreviewDialog;
